import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";

import { ProfileDetails } from "../v3";
import { AdminService } from "../../services";
import { EDIT_USER } from "../../constants";
import { formatBalance, getBalanceColor, useHasPermission } from "../../utils";
import { USER_AVATAR } from "../../utils/image.constants";

export const UserDetails = ({ onSuccess = () => {}, reloadData }) => {
  const [userDetails, setUserDetails] = useState({});
  const [isActive, setIsActive] = useState(false);

  const { id } = useParams();

  const { user } = useSelector((state) => state.user);
  const hasUserEdit = useHasPermission(EDIT_USER);
  const canUserEdit = hasUserEdit && Number(user?.id) !== Number(id);

  useEffect(() => {
    fetchData(id);
  }, [id, reloadData]);

  const fetchData = async (userId) => {
    try {
      const { data: userDetails } = await AdminService.getUserDetails(userId);
      setUserDetails(userDetails);
      setIsActive(userDetails?.active);

      onSuccess?.({
        accountId: userDetails?.accounts?.[0]?.id,
        firstName: userDetails?.firstName,
        lastName: userDetails?.lastName,
      });
    } catch (error) {
      toast.error("Failed to fetch user details");
      console.error("🚀 ~ fetchData ~ error:", error);
    }
  };

  const handleStatusChange = async (e) => {
    const updatedStatus = e.target.checked;
    try {
      await AdminService.updateUser(id, { active: updatedStatus });
      setIsActive(updatedStatus);
      toast.success("Status updated successfully");
    } catch (error) {
      toast.error("Failed to update status");
      console.error("🚀 ~ handleStatusChange ~ error:", error);
    }
  };

  const invertBalance = (balance) => -(Number(balance) || 0);

  return (
    <ProfileDetails
      profileImage={USER_AVATAR}
      name={`${userDetails?.firstName} ${userDetails?.lastName}`}
      subtitle={userDetails?.role?.name}
      phone={userDetails?.primaryPhone}
      isActive={isActive}
      canToggle={canUserEdit}
      onToggle={(e) => handleStatusChange(e)}
      infoFields={[
        {
          label: "Balance",
          value: formatBalance(invertBalance(userDetails?.accounts?.[0]?.balance)),
          color: getBalanceColor(Number(userDetails?.accounts?.[0]?.balance)),
        },
        { label: "User Name", value: userDetails?.username },
        { label: "Email", value: userDetails?.primaryEmail },
      ]}
    />
  );
};
